import { render, staticRenderFns } from "./ErrorIe.vue?vue&type=template&id=2a57b4cf&"
import script from "./ErrorIe.vue?vue&type=script&lang=ts&"
export * from "./ErrorIe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports